export default "__VITE_ASSET__DiWxkjoK__"